/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PutV2UsersByUserIdParams,
  DeleteV2UsersByUserIdParams,
  PutV2UsersMarketingByUserIdParams,
  GetV2UsersProfilePhotoByUserIdParams,
  GetV2UsersMarketingOffByUserIdParams,
  PutV2UsersMarketingByUserIdQuery,
  PutV2UsersByUserIdBody,
  DeleteV2UsersByUserIdBody,
  PutV2UsersPasswordResetBody,
  PostV2UsersPasswordResetBody,
  PostV2UsersProfilePhotoBody,
  PutV2UsersByUserIdResponse,
  PutV2UsersMarketingByUserIdResponse,
  GetV2UsersMarketingOffByUserIdResponse,
  GetV2UsersProjectsResponse,
  GetV2UsersProjectsArchivedResponse,
  GetV2UsersInfoResponse,
} from '../types';

export class Users extends Controller {
  async putV2UsersByUserId<
    T extends PutV2UsersByUserIdResponse,
    D,
    C extends PutV2UsersByUserIdBody
  >(
    body: C,
    { userId }: PutV2UsersByUserIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/users/${userId}`,
      body,
      axiosConfig
    );
  }

  async deleteV2UsersByUserId<T, D, C extends DeleteV2UsersByUserIdBody>(
    { userId }: DeleteV2UsersByUserIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/users/${userId}`,
      { ...axiosConfig, data: body }
    );
  }

  async putV2UsersMarketingByUserId<
    T extends PutV2UsersMarketingByUserIdResponse,
    D,
    C extends null
  >(
    body: C,
    { userId }: PutV2UsersMarketingByUserIdParams,
    query: PutV2UsersMarketingByUserIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/users/${userId}/marketing`, query),
      body,
      axiosConfig
    );
  }

  async putV2UsersPasswordReset<T, D, C extends PutV2UsersPasswordResetBody>(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      '/v2/users/password-reset',
      body,
      axiosConfig
    );
  }

  async postV2UsersPasswordReset<T, D, C extends PostV2UsersPasswordResetBody>(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/users/password-reset',
      body,
      axiosConfig
    );
  }

  async postV2UsersProfilePhoto<T, D, C extends PostV2UsersProfilePhotoBody>(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/users/profile/photo',
      body,
      axiosConfig
    );
  }

  async deleteV2UsersProfilePhoto<T, D, C extends null>(
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      '/v2/users/profile/photo',
      { ...axiosConfig, data: body }
    );
  }

  async getV2UsersProfilePhotoByUserId<T, D, C>(
    { userId }: GetV2UsersProfilePhotoByUserIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/users/${userId}/profile/photo`,
      axiosConfig
    );
  }

  async getV2UsersMarketingOffByUserId<
    T extends GetV2UsersMarketingOffByUserIdResponse,
    D,
    C
  >(
    { userId }: GetV2UsersMarketingOffByUserIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/users/${userId}/marketing/off`,
      axiosConfig
    );
  }

  async getV2UsersProjects<T extends GetV2UsersProjectsResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/v2/users/projects',
      axiosConfig
    );
  }

  async getV2UsersProjectsArchived<
    T extends GetV2UsersProjectsArchivedResponse,
    D,
    C
  >(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/v2/users/projects/archived',
      axiosConfig
    );
  }

  async getV2UsersInfo<T extends GetV2UsersInfoResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/v2/users/info',
      axiosConfig
    );
  }
}
